









import { Component, Vue } from 'vue-property-decorator';
import orderApi from '@/api/order';
import { HttpResponse } from '@/interface/common';
import { getUrlParam } from '@/utils/common';
import { Toast } from 'vant';

const type = getUrlParam('type');
const title = getUrlParam('title');

@Component({
  name: 'PreviewAgreement'
})

export default class UserPrivacy extends Vue {
  contractData = '';

  created() {
    document.title = title;
    this.getAgreementContent();
  }

  // 获取协议内容
  getAgreementContent() {
    this.$http({
      url: orderApi.contractPreview.url + '/' + type,
      method: orderApi.contractPreview.method
    }).then((res: HttpResponse<string>) => {
      this.contractData = res.data;
    });
  }

  // 处理链接点击
  handleLinkClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (target.tagName === 'A') {
      event.preventDefault();
      const link = (target as HTMLAnchorElement).href;

      console.log('href', link);

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(() => {
          Toast.success('复制成功，请在浏览器中打开查看。');
        }).catch(() => {
          this.fallbackCopy(link);
        });
      } else {
        this.fallbackCopy(link);
      }
    }
  }

  fallbackCopy(text: string) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      Toast.success('复制成功，请在浏览器中打开查看。');
    } catch (err) {
      Toast.success(`请手动复制链接：${text}`);
    }

    document.body.removeChild(textarea);
  }
}
